///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum ProjectUnits {
    FEET = 'feet',
    METER = 'meter'
}

export enum ProjectListViewType {
    TABLE = 'table',
    CARDS = 'cards'
}
